export default __webpack_public_path__ + "img/credit-card.3ca6575c.svg";